import { render, staticRenderFns } from "./MappingDescriptionBlock.vue?vue&type=template&id=2e8530fd&"
import script from "./MappingDescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./MappingDescriptionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports